module.exports = __webpack_public_path__ + "media/images/banner-tacos-882982a76bb6cfda4cf81e606508097c.png";